import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import InitialsSymbol from '../User/initialsSymbol';

const UserCard = ({ item, tooltip = null }) => {
  return (
    <div className="d-flex align-items-center justify-content-start py-2 cursor-pointer mb-2">
      <div className="me-2">
        <InitialsSymbol
          initials={item.initials}
          circle={true}
          color={item.color || item.user_color}
        />
      </div>

      {/* Primary / Secondary Text */}
      <div className="d-flex flex-column">
        <span className="text-gray-800 text-hover-primary fw-semibold mb-1">
          {item.primary}
        </span>
        {tooltip ? (
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip style={{ width: 300 }} id="tooltip-bottom">
                {tooltip(item)}
              </Tooltip>
            }
          >
            <span className="text-gray-600">{item.secondary}</span>
          </OverlayTrigger>
        ) : (
          <span className="text-gray-600">{item.secondary}</span>
        )}
      </div>
    </div>
  );
};

export default UserCard;
